// extracted by mini-css-extract-plugin
export default {"container":"Shorts_container__qnib4","shortsWrapper":"Shorts_shortsWrapper__Qw1G6","thumbnail":"Shorts_thumbnail__+G4LU","playButton":"Shorts_playButton__kVWV4"};